import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../Loader";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import CustomDownloadButton from "../../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import { Chip, Paper } from "@mui/material";
import ListInfo from "../../BookModule/BookModule.module.css";
import DatePickerSample from "../../../DatePicker";
import moment from "moment";
import ViewIcon from "../../BookModule/AdminSide/BookTabs/ViewIcon.png";
import { AxiosInstance } from "../../../../../axios";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { R_PER_PAGE } from "../../../../../labels";
import { styled } from "@mui/material/styles";
import { Search } from "@mui/icons-material";

function ListInterviewDetails() {
  let page = R_PER_PAGE;
  const navigate = useNavigate();
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);

  const isComingFromDetailToList =
    prevPathRef.current?.startsWith("/ListInterviewDetails/") &&
    location.pathname === "/Interviewlist";

  // ✅ Persist route state safely
  const routeStateRef = useRef(null);

  if (isComingFromDetailToList) {
    // ✅ Clear ONLY when coming from detail → list
    routeStateRef.current = null;
  } else if (
    routeStateRef.current === null &&
    location.state &&
    Object.keys(location.state).length > 0
  ) {
    // ✅ Cache first valid state only
    routeStateRef.current = location.state;
  }

  // update previous path
  prevPathRef.current = location.pathname;

  const {
    BATCHID,
    TYPE,
    filLastDate,
    filInterviewDate,
    filStatus,
    filCateSearch,
  } = routeStateRef.current || {};

  const handleAllClear = () => {
    setSearchTerm("");
    setStatusOn([]);
    setUpdateChipData([]);
    setAppOns([]);
    setAppDatas({
      FDate: "",
      TDate: "",
      Days: "",
    });
    setAppOn([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
    });
  };

  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const currentPath = location.pathname;
    const isFromDetailToList =
      prevPath.startsWith("/ListInterviewDetails/") &&
      currentPath === "/Interviewlist";
    if (isFromDetailToList) {
      navigate("/Interviewlist", {
        replace: true,
        state: null,
      });

      handleAllClear();
    }

    prevPathRef.current = currentPath;
  }, [location.pathname, location.state, navigate]);

  // Ref Element
  const filterRefss = useRef(null);
  const filterInterviewRef = useRef(null);
  const filterLastRef = useRef(null);
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const fDatePickerLastRef = useRef(null);
  const tDatePickerLastRef = useRef(null);
  const txtBSearch = useRef(null);

  const [appOn, setAppOn] = useState([]);
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  const [appOns, setAppOns] = useState([]);
  const [appDatas, setAppDatas] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });

  const [isOpen, setIsOpen] = useState({
    status: false,
    interview_date: false,
    last_date: false,
  });
  const [statusOn, setStatusOn] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [updateListData, setUpdateListData] = useState();
  const [updateChipData, setUpdateChipData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [searchTerm, setSearchTerm] = useState("");
  const { batch_id } = useParams();
  const generatePDF = () => {
    const headers = [
      "Interview Name",
      "Interview Date",
      "Last Date to Apply",
      "Student Enrolled",
      "Number of panels",
      "Result Status",
    ];

    const rows = csvData.map((item, index) => [
      item.interview_name ?? "",
      item.interview_date ?? "",
      item.last_dt_apply ?? "",
      item.students_enrolled ?? "",
      item.panel_count ?? "",
      // item.result_status == 0
      //   ? "Not Yet Published"
      //   : item.result_status == 1
      //   ? "Published"
      //   : "-",
      item.result_status ?? "",
    ]);

    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "InterviewList Data",
          headers,
          rows,
          filename: "InterviewList.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };
  const csvHeaders = [
    { label: "Serial Number", key: "serialNumber" },
    { label: "Interview Name", key: "interview_name" },
    { label: "Interview Date", key: "interview_date" },
    { label: "Last Date to Apply", key: "last_dt_apply" },
    { label: "Student Enrolled", key: "students_enrolled" },
    { label: "Number of Panels", key: "panel_count" },
    { label: "Result Status", key: "result_status" },
  ];
  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };
        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };
  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };
        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOns([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };
  let filterSearch = [];
  function updateStateData() {
    filterStatus = statusOn;
    filterApplyeds = appOns;
    filterApplyed = appOn;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }
  useEffect(() => {
    setUpdateListData(updateListData);
  }, [updateListData]);
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };
  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "NotYetPublished" || typename === "Published") {
      if (checked) {
        setStatusOn((prev) => [
          { id: parseInt(value), name: name, type: "status" },
        ]);
      } else {
        setStatusOn((prev) =>
          prev.filter((item) => item.id !== parseInt(value))
        );
      }
    }
  };
  const handleClear = (name) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      status: false,
      interview_date: false,
      last_date: false,
    });
    if (name === "status") {
      updateStateData();
      setStatusOn([]);
      filterStatus = [];
    } else if (name === "appliedOn") {
      updateStateData();
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setIsOpen({
        ...isOpen,
        interview_date: false,
      });
    } else if (name === "appliedOns") {
      updateStateData();
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
      setIsOpen({
        ...isOpen,
        interview_date: false,
      });
    }
    setTimeout(() => {
      loadChipdata();
    }, 500);
  };
  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "appliedOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        interview_date: false,
      });
    } else if (name === "appliedOns") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        last_date: false,
      });
    }
  };
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        status: !prevState.status, // Toggle the value
        interview_date: false,
        last_date: false,
      }));
      setStatusOn(updateChipData.filter((ui) => ui.type === "status"));
    } else if (boxName === "interview_date") {
      setIsOpen((prevState) => ({
        status: false,
        interview_date: !prevState.interview_date,
        last_date: false,
      }));
    } else if (boxName === "last_date") {
      setIsOpen((prevState) => ({
        status: false,
        last_date: !prevState.last_date,
        interview_date: false,
      }));
    }
  };

  function loadListdata() {
    let tempStaus = [];

    statusOn.map((obj) => {
      tempStaus.push(Number(obj.id));
    });

    let statusFilter = {
      batch_id: batch_id || "",
      search: searchTerm || "",
      category: "",
      course: "",
      batch_name: "",
      page: "",
      page_size: "",
      int_start_date: appOn.length > 0 ? appOn[0].fdate || appOn[0].FDate : "",
      int_end_date: appOn.length > 0 ? appOn[0].edate || appOn[0].TDate : "",
      lt_start_date:
        appOns.length > 0 ? appOns[0].fdate || appOns[0].FDate : "",
      lt_end_date: appOns.length > 0 ? appOns[0].edate || appOns[0].TDate : "",
      result_status: statusOn.length > 0 ? tempStaus : "",
    };
    setIsLoading(true);
    AxiosInstance.post("/api/mockinterview/interview/list", statusFilter)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          setCurrentPage(1);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));

          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            interview_name: item.interview_name,
            interview_date: `${moment(item.interview_date).format(
              "DD/MM/YYYY"
            )}`,
            last_dt_apply: `${moment(item.last_dt_apply).format("DD/MM/YYYY")}`,
            panel_count: item.panel_count,
            students_enrolled: item.students_enrolled,
            result_status:
              item.result_status === 0
                ? "Not Yet Published"
                : item.result_status === 1
                ? "Published"
                : "-",
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }
  let filterStatus = [];
  let filterApplyed = [];
  let filterApplyeds = [];

  useEffect(() => {
    filterApplyed = appOn;
  }, [appData]);
  useEffect(() => {
    filterApplyeds = appOns;
  }, [appDatas]);
  useEffect(() => {
    filterStatus = statusOn;
  }, [statusOn]);

  useEffect(() => {
    // Set filter variables BEFORE calling loadChipdata
    if (filStatus && filStatus.length > 0) {
      setStatusOn(filStatus);
      filterStatus = filStatus;
    } else {
      setStatusOn(statusOn);
      filterStatus = statusOn;
    }
    if (filInterviewDate && filInterviewDate.length > 0) {
      const filterDates = filInterviewDate[0];
      setAppData({
        FDate: filterDates.fdate,
        TDate: filterDates.edate,
        Days: filterDates.Days,
        name: "",
      });
      setAppOn(filInterviewDate);
      filterApplyed = filInterviewDate;
    }
    if (filLastDate && filLastDate.length > 0) {
      const filterDates = filLastDate[0];
      setAppDatas({
        FDate: filterDates.fdate,
        TDate: filterDates.edate,
        Days: filterDates.Days,
        name: "",
      });
      setAppOns(filLastDate);
      filterApplyeds = filLastDate;
    }
    if (filCateSearch) {
      setSearchTerm(filCateSearch);
      filterSearch = [{ name: filCateSearch, type: "search" }];
    }
    setIsFiltersInitialized(true);
    // Build chips directly here instead of calling loadChipdata
    let tempArr = [];
    if (filStatus && filStatus.length > 0) {
      filStatus.forEach((obj) => tempArr.push(obj));
    }
    if (filInterviewDate && filInterviewDate.length > 0) {
      filInterviewDate.forEach((obj) => tempArr.push(obj));
    }
    if (filLastDate && filLastDate.length > 0) {
      filLastDate.forEach((obj) => tempArr.push(obj));
    }
    if (filCateSearch && filCateSearch.length > 0) {
      tempArr.push({ name: filCateSearch, type: "search" });
    }
    setUpdateChipData(tempArr);
  }, [filStatus, filInterviewDate, filLastDate, filCateSearch]);

  useEffect(() => {
    if (isFiltersInitialized && filStatus && filStatus.length > 0) {
      loadListdata();
    } else if (
      isFiltersInitialized &&
      filInterviewDate &&
      filInterviewDate.length > 0
    ) {
      loadListdata();
    } else if (isFiltersInitialized && filLastDate && filLastDate.length > 0) {
      loadListdata();
    }
  }, [
    filStatus,
    filInterviewDate,
    filLastDate,
    isFiltersInitialized,
    updateChipData,
    location.pathname,
  ]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, updateChipData, location.pathname]);

  function loadChipdata() {
    let tempArr = [];

    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyeds.map((obj) => {
      tempArr.push(obj);
    });

    if (searchTerm.length > 0) {
      tempArr.push({ name: searchTerm, type: "search" });
    }
    setUpdateChipData(tempArr);
  }

  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "status") {
      setStatusOn(statusOn.filter((item) => item.id !== chipToDelete.id));
      filterStatus = statusOn.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "dayRanges") {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyed = [];
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    } else if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
      setUpdateChipData((prev) => {
        const filteredData = prev.filter((e) => e.type !== "search");
        return filteredData;
      });
    } else {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    }
    loadChipdata();
  };

  const handleNavigate = (idid, data) => {
    if (data?.class_mode) {
      localStorage.setItem("CLASSMODE", data.class_mode);
    }
    if (batch_id) {
      navigate(`/ViewInterviewDetails/${batch_id}/${idid}`, {
        state: {
          ID: batch_id,
          INTERVIEWDATE: appOn,
          LASTDATE: appOns,
          RESULTSTATUS: statusOn,
          CLASSMODE: data?.class_mode,
          PAGEFROM: "b",
          TYPE: TYPE,
          FSEARCH: searchTerm,
        },
      });
    } else {
      navigate(`/ViewInterviewDetails/${idid}`, {
        state: {
          ID: batch_id,
          INTERVIEWDATE: appOn,
          LASTDATE: appOns,
          RESULTSTATUS: statusOn,
          PAGEFROM: "l",
          FSEARCH: searchTerm,
        },
      });
    }
  };

  // Pagination
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);
  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData?.slice(start, end);

  const handleBackFilter = () => {
    navigate(`/DetailViewBatch/${BATCHID}/${TYPE}`);
  };
  // const handleSearch = (event) => {
  //   if (event.key === "Enter") {
  //     let val = event.target.value;
  //     setSearchTerm(val);
  //     if (val.length > 0) {
  //       setUpdateChipData((prev) => [
  //         ...prev,
  //         { name: String(val), type: "search" },
  //       ]);
  //     } else {
  //       setSearchTerm("");
  //     }
  //   }
  // };
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value.trim();

      if (val.length > 0) {
        // Check if search chip already exists, remove it first

        const filteredChips = updateChipData.filter(
          (chip) => chip.type !== "search"
        );

        setSearchTerm(val);

        setUpdateChipData([
          ...filteredChips,
          { name: String(val), type: "search" },
        ]);

        // Clear the input field

        event.target.value = "";
      }
    }
  };

  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`BathHeader global_container BathDet`}>
      <div className="col-md-6 col-12 px-0">
        <h2 className="TitleHeader">Interview</h2>
      </div>
      <div className="row mx-0">
        <div className="col-lg-3 col-md-3 mb-3 col-sm-12 col-xs-12 px-0">
          {!TYPE && (
            <div class={ListInfo.searchInputSec}>
              <input
                className={`${ListInfo.searchInput} w-100`}
                type="text"
                placeholder="Search by interview name"
                name="search_book_title"
                onKeyDown={handleSearch}
                ref={txtBSearch}
              />
              <Search
                onClick={handleSearchFocus}
                className={`${ListInfo.ListsearchIcon}`}
              />
            </div>
          )}
        </div>
        <div className="col-lg-9 col-md-9 col-12 px-0">
          <ul class="List-Button">
            {TYPE === 5 && (
              <li class="ListBtnItems">
                <Link
                  onClick={handleBackFilter}
                  to="javascript:void(0)"
                  className="secondaryButton "
                >
                  Back to View Mock Interview Batch
                </Link>
              </li>
            )}
            <li class="ListBtnItems">
              <CustomDownloadButton
                csvListData={csvData?.length > 0 ? csvData : ""}
                headers={csvHeaders}
                iconName=" file_download "
                filename={"InterviewList.csv"}
                csvName="  Download as CSV"
              />
            </li>
            <li class="ListBtnItems primaryButton" onClick={generatePDF}>
              <span className="material-icons me-1 align-middle text-white">
                file_download
              </span>
              Download as PDF
            </li>
          </ul>
        </div>
      </div>

      {updateChipData?.length > 0 ? (
        <div className="row mx-0">
          <div className="col-md-12 px-0 col-sm-12 col-xs-12 paperil_global">
            <Paper
              sx={{
                display: "flex",
                flexWrap: "wrap",
                listStyle: "none",
                boxShadow: "none",
                p: 0,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData.map((data, index) => {
                let icon;
                return (
                  <ListItem key={index}>
                    <Chip
                      icon={icon}
                      label={
                        <>
                          <span className={ListInfo.BoldTyText}>
                            {data.name}
                          </span>
                        </>
                      }
                      onDelete={handleDelete(data, index)}
                    />
                  </ListItem>
                );
              })}
              <ListItem className="clearAll_list">
                <a
                  className="clearAll_listItem"
                  href="javascript:void(0)"
                  onClick={handleAllClear}
                >
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        // No chips to show
        <div></div>
      )}
      <div className="row mx-0 mt-2">
        <div
          className={`col-md-12 ${ListInfo.table_responsive_padding} table-responsive tableMinHeight px-0 `}
        >
          <table className="table" id="tableListHeader">
            <thead>
              <tr>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "serialNumber")}
                    className="textHead_th"
                  >
                    S.No.
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "serialNumber")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "interview_name")}
                    className="textHead_th"
                  >
                    Interview Name
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "interview_name")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterInterviewRef}
                >
                  <span
                    onClick={(e) => handleSort(e, "interview_date")}
                    className="textHead_th"
                  >
                    Interview Date
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "interview_date")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                  <span
                    onClick={(e) => handleFilter(e, "interview_date")}
                    class={` align-middle material-icons ${
                      (appData &&
                        Object.entries(appData).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                      isOpen.interview_date
                        ? ListInfo.active_icons_book
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.interview_date === true && (
                    <div className="filterBoxs_testlist container mt-2   p-1">
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                                                                                   /> */}
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              class={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate}
                              fieldInput={appData.FDate}
                              txtAdMDob={fDatePickerRef}
                              // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                                                                                   /> */}
                            <DatePickerSample
                              class={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate}
                              fieldInput={appData.TDate}
                              txtAdMDob={tDatePickerRef}
                              minDate={appData.FDate}
                            />
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("appliedOn")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={(e) => {
                              e.preventDefault();
                              handleApplyFilter("appliedOn");
                            }}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterLastRef}
                >
                  <span
                    onClick={(e) => handleSort(e, "last_date")}
                    className="textHead_th"
                  >
                    Last Date to Apply
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "last_date")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                  <span
                    onClick={(e) => handleFilter(e, "last_date")}
                    class={` align-middle material-icons ${
                      (appDatas &&
                        Object.entries(appDatas).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                      isOpen.last_date
                        ? ListInfo.active_icons_book
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.last_date === true && (
                    <div className="filterBoxs_testlist container mt-2   p-1">
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                                                                                   /> */}
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              class={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appDatas.FDate}
                              txtAdMDob={fDatePickerLastRef}
                              // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                                                                                   /> */}
                            <DatePickerSample
                              class={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appDatas.TDate}
                              txtAdMDob={tDatePickerLastRef}
                              minDate={appDatas.FDate}
                            />
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("appliedOns")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={(e) => {
                              e.preventDefault();
                              handleApplyFilter("appliedOns");
                            }}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "book_title")}
                    className="textHead_th"
                  >
                    Student Enrolled
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "book_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "book_title")}
                    className="textHead_th"
                  >
                    Number of Panels
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "book_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterRefss}
                >
                  <div class={ListInfo.thcontent}>
                    <span
                      onClick={(e) => handleSort(e, "status")}
                      class="textHead_th"
                    >
                      Result <br /> Status
                    </span>
                    <div class={ListInfo.iconcontainer}>
                      <span
                        onClick={(e) => handleSort(e, "status")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                      <span
                        className={`textHead_th align-middle material-icons ${
                          statusOn.length > 0 || isOpen.status
                            ? ListInfo.active_icons_book
                            : ""
                        } `} // Change here
                        onClick={(e) => handleFilter(e, "status")}
                      >
                        filter_list
                      </span>
                      {/* 0 : waiting for approvel 1 : approved 2 : reject */}
                      {isOpen.status && (
                        <>
                          <div className="filterBoxs_testlist mt-3">
                            <div className="col-md-12 form-check filterStatus_list">
                              <ul className="ulFilterListData">
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={"Not Yet Published"}
                                    value={0}
                                    id={"NotYetPublished"}
                                    checked={statusOn.some((element) => {
                                      if (element.id == 0) {
                                        return true;
                                      }
                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        "NotYetPublished",
                                        "NotYetPublished"
                                      )
                                    }
                                  />
                                  <label
                                    className={`form-check-label filterChipText  ms-3  ${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusPink}`}
                                    htmlFor={"NotYetPublished"}
                                  >
                                    Not Yet Published
                                  </label>
                                </li>
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={"Published"}
                                    value={1}
                                    checked={statusOn.some((element) => {
                                      if (element.id == 1) {
                                        return true;
                                      }
                                      return false;
                                    })}
                                    id={"Published"}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        "Published",
                                        "Published"
                                      )
                                    }
                                  />
                                  <label
                                    className={`form-check-label filterChipText  ms-3  ${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusGreen}`}
                                    htmlFor={"Published"}
                                  >
                                    Published
                                  </label>
                                </li>
                              </ul>
                            </div>
                            <div className="borderWidth row">
                              <ul className="List-Button">
                                <li className="ListBtnItems">
                                  <Link
                                    to={"javascript:void(0)"}
                                    onClick={() => handleClear("status")}
                                    className="secondaryButton "
                                  >
                                    Clear
                                  </Link>
                                </li>
                                <li className="ListBtnItems">
                                  <Link
                                    disabled={
                                      statusOn.length === 0 ? true : false
                                    }
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleApplyFilter("status");
                                    }}
                                    className="primaryButton"
                                  >
                                    Apply Filter
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </th>{" "}
                <th id="th" className={ListInfo.tableThPadding}>
                  <span className="textHead_th">Action</span>
                </th>
              </tr>
            </thead>

            <tbody>
              {currentData?.length === 0 ? (
                <tr>
                  <td colspan="15" style={{ textAlign: "center" }}>
                    No records to display
                  </td>
                </tr>
              ) : (
                currentData?.map((kl, ind) => (
                  <tr key={ind}>
                    <td id="td">{kl.serialNumber}</td>
                    <td id="td">
                      <span
                        title={kl.interview_name}
                        className={ListInfo.ellipsisText}
                      >
                        {kl.interview_name ? kl.interview_name : "_"}
                      </span>
                    </td>
                    <td id="td">
                      {kl.interview_date
                        ? moment(kl.interview_date).format("DD/MM/YYYY")
                        : "_"}
                    </td>
                    <td id="td">
                      {kl.last_dt_apply
                        ? moment(kl.last_dt_apply).format("DD/MM/YYYY")
                        : "_"}
                    </td>
                    <td id="td">
                      <span
                        title={kl.students_enrolled}
                        className={ListInfo.ellipsisText}
                      >
                        {kl.students_enrolled ?? "_"}
                      </span>
                    </td>
                    <td id="td">
                      <span
                        title={kl.panel_count}
                        className={ListInfo.ellipsisText}
                      >
                        {kl.panel_count ?? "_"}
                      </span>
                    </td>
                    <td id="td">
                      {kl.result_status == 0 && (
                        <span
                          className={`${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusPink}`}
                        >
                          Not Yet Published{" "}
                        </span>
                      )}
                      {kl.result_status == 1 && (
                        <span
                          className={`${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusGreen}`}
                        >
                          Published
                        </span>
                      )}
                    </td>
                    <td id="td">
                      <img
                        src={ViewIcon}
                        className={ListInfo.cursor_pointer}
                        onClick={() => handleNavigate(kl.interview_id, kl)}
                        alt="view icon"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="row mt-2">
        <Pagination
          rowsPerPage={rowsPerPage}
          handlePageCount={handlePageCount}
          startPage={
            updateListData && updateListData?.length > 0
              ? currentPage * rowsPerPage + 1 - rowsPerPage
              : 0
          }
          endPage={
            updateListData && updateListData?.length > 0
              ? updateListData?.length < currentPage * rowsPerPage
                ? updateListData?.length
                : currentPage * rowsPerPage
              : 0
          }
          totalRecords={
            updateListData && updateListData?.length > 0
              ? updateListData?.length
              : 0
          }
          handlePrev={(e) => handlePrev(currentPage - 1)}
          currentPrevPage={currentPage === 1}
          prevButton={`${ListInfo.prev_buttonViewAllbook} ${ListInfo.materialIconsRightAndLeft} me-2`}
          handleNext={() => handleNext(currentPage + 1)}
          currentNextPage={currentPage === totalPages || totalPages == 0}
        />
      </div>
    </div>
  );
}

export default ListInterviewDetails;
